import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";
import { login, validateToken } from "../services/authService";
import Worker from "../images/background/1.jpg";

// Reset global e estilos base
const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  body {
    font-family: "Inter", sans-serif;
    background-color: #f5f5f5;
  }
`;

const Container = styled.div`
  display: flex;
  min-height: 100vh;
`;

const FormSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const FormBox = styled.div`
  background: #fff;
  padding: 40px;
  max-width: 400px;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 480px) {
    padding: 20px;
  }
`;

const ImageSection = styled.div`
  flex: 1;
  display: block;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Title = styled.h4`
  text-align: center;
  margin-bottom: 10px;
`;

const Subtitle = styled.p`
  text-align: center;
  color: #6c757d;
  margin-bottom: 20px;
`;

const ErrorMessage = styled.div`
  background: #f8d7da;
  color: #721c24;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
  text-align: center;
`;

const FormGroup = styled.div`margin-bottom: 15px;`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-size: 0.9rem;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: border-color 0.3s;

  &:focus {
    border-color: #1565c0;
    outline: none;
  }
`;

const CheckboxWrapper = styled.div`
  margin-bottom: 15px;
  display: flex;
  align-items: center;
`;

const CheckboxInput = styled.input`margin-right: 8px;`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 12px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #0069d9;
  }
`;

const ForgotPassword = styled.a`
  display: block;
  text-align: right;
  color: #6c757d;
  font-size: 0.8rem;
  text-decoration: none;
  margin-bottom: 15px;
`;

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Verifica se já existe um token válido e redireciona o usuário
  useEffect(
    () => {
      const checkToken = async () => {
        const isValid = await validateToken();
        if (isValid) {
          navigate("/customer-management");
        }
      };
      checkToken();
    },
    [navigate]
  );

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const data = await login(email, password);
      if (data.token) {
        navigate("/customer-management");
      }
    } catch (err) {
      setError(err.response ? err.response.data.msg : "Erro no servidor");
    }
  };

  return (
    <React.Fragment>
      <GlobalStyle />
      <Container>
        <FormSection>
          <FormBox>
            <Title>Unity elevadores</Title>
            <Subtitle>Insira suas credenciais para acessar o sistema.</Subtitle>
            {error &&
              <ErrorMessage>
                {error}
              </ErrorMessage>}
            <form onSubmit={handleSubmit}>
              <FormGroup>
                <Label htmlFor="email">#Id</Label>
                <Input
                  type="text"
                  id="email"
                  placeholder="Insira sua identificação."
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
              </FormGroup>
              <FormGroup>
                <ForgotPassword href="#">Esqueceu sua senha?</ForgotPassword>
                <Label htmlFor="password">Senha</Label>
                <Input
                  type="password"
                  id="password"
                  placeholder="Entre com sua senha."
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                />
              </FormGroup>
              <CheckboxWrapper>
                <CheckboxInput type="checkbox" id="checkbox-signin" />
                <Label htmlFor="checkbox-signin">Lembrar-me</Label>
              </CheckboxWrapper>
              <SubmitButton type="submit">Entrar</SubmitButton>
            </form>
          </FormBox>
        </FormSection>

        <ImageSection>
          <img
            src={Worker}
            alt="Maintenance Worker"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover"
            }}
          />
        </ImageSection>
      </Container>
    </React.Fragment>
  );
};

export default LoginPage;
